import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import Button from '../Button';

import styles from './Tab.module.scss';

const cx = classNames.bind(styles);

const defualtFn = () => {};

const Tab = ({
  active = '',
  content = '',
  id = '',
  onClick = '',
  onChange = defualtFn,
  variant = 'underlined',
  className = ''
}) => {
  const handleClick = () => {
    onClick(id);
    onChange(id);
  };

  const tabClassName = cx(
    styles.tab,
    styles[variant],
    {
      [styles.active]: active
    },
    className
  );

  return (
    <Button
      color="tab-link"
      size="small"
      onClick={handleClick}
      className={tabClassName}
    >
      {content}
    </Button>
  );
};

Tab.propTypes = {
  active: PropTypes.bool,
  content: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  variant: PropTypes.oneOf(['outlined', 'underlined']),
  className: PropTypes.string
};

export default Tab;
